<div class="evento-item">
      <div class="capa" (click)="toRoute()">
            <figure *ngIf="data.imagem != null">
                  <img [src]="data.imagem" [alt]="data.nome" width="100%"  loading="lazy" />
            </figure>
            <figure *ngIf="data.imagem == null">
                  <img src="/images/sem-foto/default.jpg" [alt]="data.nome" width="100%"  loading="lazy" />
            </figure>
      </div>
      <div class="content">
            <h3>{{data.nome}}</h3>
            <h4 *ngIf="data.local != null && data.local != ''">{{data.local}}</h4>
            <div class="info">
                  <div class="item">
                        <span>{{data | eventoDateFormat}}</span>
                  </div>
            </div>
            <div class="content-button">
                  <button type="button" (click)="toRoute()">
                        <span>Saiba mais</span>
                  </button>
            </div>
      </div>
</div>
